import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeFilledSvg from "@ant-design/icons-svg/es/asn/CodeFilled";
import AntdIcon from '../components/AntdIcon';
var CodeFilled = function CodeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CodeFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CodeFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CodeFilled';
}
export default RefIcon;